<ng-container *ngIf="isAcmic && policy?.policyStatus === 'ACTIVE' 
                        && policy?.policyType === 'AUTO' && vehEligibleForIdCard?.length > 0">
    <div class="acmic-dash-id-card-container">          
        <ng-container *ngIf="vehEligibleForIdCard?.length > 1; else singleVehicleOrNonOwned">
            <div class="label-col">
            {{ 'ID Cards' | translate }}
            </div>
        </ng-container>
        <ng-template #singleVehicleOrNonOwned>
            <div class="label-col">
            {{ 'ID Card' | translate }}
            </div>
            <div class="id-card-actions mobile-flex-col mt-4">
            <mapfre-button          
                [additionalClasses]="'view-id-card'"
                (click)="getIdCardDocument('view')"> {{"View" | translate}}
            </mapfre-button>
            <mapfre-button                      
                [additionalClasses]="'download-btn'"
                (click)="getIdCardDocument('download')"> {{ "DOWNLOAD" | translate}}
            </mapfre-button>
            </div>
        </ng-template>
    </div>
    <div class="policy-info-row mt-4" *ngIf="vehEligibleForIdCard?.length > 1">
      <div class="index-{{index}} w-100-percent">
        <app-id-cards 
          [isPolicyExists]="true"
          [setMarginTop]="24" 
          [policyId]="policy?.policynumber?.policyNumber" 
          [policies]="activePolicyArray" 
          [navFrom]="'dashboard'" 
          [index]="index">
        </app-id-cards>
      </div>
    </div>
    <hr class="thin-hr-mb-24 mt-4">
  </ng-container>